<template>
  <div class="dashboard p-4">
    <!-- Encabezdo -->
    <div class="mt-2 w-full">
      <div class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between">
        <div>
          <p class="text-xs text-gray-700 dark:text-gray-300 font-semibold">Panel de Control</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
          Ventas y Servicio Técnico
          </h1>
          <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Resumen operativo y financiero en tiempo real
          </p>
        </div>
        <div class="flex gap-2">
         
        </div>
      </div>
    </div>

    <!-- Estado de carga -->
    <div v-if="loading" class="mt-6 text-center py-12">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p class="text-gray-600 dark:text-gray-400">Cargando datos del dashboard...</p>
    </div>

    <!-- Sin datos -->
    <div v-else-if="!hayDatos" class="mt-6 text-center py-12">
      <Icon icon="mdi:database-off" class="text-4xl text-gray-400 mx-auto mb-4" />
      <p class="text-gray-600 dark:text-gray-400">No hay datos disponibles para mostrar</p>
      <p class="text-sm text-gray-500 dark:text-gray-500 mt-2">Registra ventas, clientes y pagos para ver estadísticas</p>
    </div>

    <!-- Contenido principal -->
    <div v-else>
      <!-- Grid de tarjetas -->
      <div class="wrapper-card grid lg:grid-cols-4 grid-cols-1 md:grid-cols-2 gap-4 mt-5">
        <!-- Ingresos Totales -->
        <div class="card bg-white dark:bg-gray-800 w-full rounded-xl p-5 border dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-300">
          <div class="flex items-center">
            <div class="p-2 max-w-sm">
              <div class="bg-gradient-to-r from-green-200 to-emerald-200 rounded-xl w-14 h-14 text-lg p-3 text-green-600 dark:text-green-500 mx-auto flex items-center justify-center">
                <Icon icon="mdi:currency-usd" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-semibold text-gray-900 dark:text-gray-200 text-2xl">
                {{ formatCurrencyUSD(estadisticas.totalIngresosUSD) }}
              </p>
              <h2 class="font-normal text-gray-400 text-md mt-1">Ingresos Totales</h2>
              <div class="flex items-center mt-2 text-sm">
                <Icon icon="mdi:trending-up" class="text-green-500 mr-1" v-if="estadisticas.variacionIngresos > 0" />
                <Icon icon="mdi:trending-down" class="text-red-500 mr-1" v-else-if="estadisticas.variacionIngresos < 0" />
                <Icon icon="mdi:minus" class="text-gray-500 mr-1" v-else />
                <span :class="[
                  estadisticas.variacionIngresos > 0 ? 'text-green-600 dark:text-green-400' : 
                  estadisticas.variacionIngresos < 0 ? 'text-red-600 dark:text-red-400' : 
                  'text-gray-600 dark:text-gray-400'
                ]">
                  {{ estadisticas.variacionIngresos !== null ? Math.abs(estadisticas.variacionIngresos) + '% vs mes anterior' : 'Sin datos previos' }}
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Ventas Totales -->
        <div class="card bg-white dark:bg-gray-800 w-full rounded-xl p-5 border dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-300">
          <div class="flex items-center">
            <div class="p-2 max-w-sm">
              <div class="bg-gradient-to-r from-blue-200 to-cyan-200 rounded-xl w-14 h-14 text-lg p-3 text-blue-600 dark:text-blue-500 mx-auto flex items-center justify-center">
                <Icon icon="mdi:cash-register" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-semibold text-gray-900 dark:text-gray-200 text-2xl">
                {{ formatNumber(estadisticas.totalVentas, 0) }}
              </p>
              <h2 class="font-normal text-gray-400 text-md mt-1">Ventas Totales</h2>
              <div class="flex items-center mt-2 text-sm">
                <Icon icon="mdi:trending-up" class="text-green-500 mr-1" v-if="estadisticas.variacionVentas > 0" />
                <Icon icon="mdi:trending-down" class="text-red-500 mr-1" v-else-if="estadisticas.variacionVentas < 0" />
                <Icon icon="mdi:minus" class="text-gray-500 mr-1" v-else />
                <span :class="[
                  estadisticas.variacionVentas > 0 ? 'text-green-600 dark:text-green-400' : 
                  estadisticas.variacionVentas < 0 ? 'text-red-600 dark:text-red-400' : 
                  'text-gray-600 dark:text-gray-400'
                ]">
                  {{ estadisticas.variacionVentas !== null ? Math.abs(estadisticas.variacionVentas) + '% vs mes anterior' : 'Sin datos previos' }}
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Pendiente por Cobrar -->
        <div class="card bg-white dark:bg-gray-800 w-full rounded-xl p-5 border dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-300">
          <div class="flex items-center">
            <div class="p-2 max-w-sm">
              <div class="bg-gradient-to-r from-amber-200 to-orange-200 rounded-xl w-14 h-14 text-lg p-3 text-amber-600 dark:text-amber-500 mx-auto flex items-center justify-center">
                <Icon icon="mdi:cash-clock" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-semibold text-gray-900 dark:text-gray-200 text-2xl">
                {{ formatCurrencyUSD(estadisticas.pendienteCobrar) }}
              </p>
              <h2 class="font-normal text-gray-400 text-md mt-1">Pendiente por Cobrar</h2>
              <div class="flex items-center mt-2 text-sm">
                <Icon icon="mdi:alert-circle" class="text-amber-500 mr-1" v-if="estadisticas.ventasPendientes > 0" />
                <Icon icon="mdi:check-circle" class="text-green-500 mr-1" v-else />
                <span :class="estadisticas.ventasPendientes > 0 ? 'text-amber-600 dark:text-amber-400' : 'text-green-600 dark:text-green-400'">
                  {{ estadisticas.ventasPendientes }} ventas {{ estadisticas.ventasPendientes > 0 ? 'pendientes' : 'al día' }}
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Clientes Activos -->
        <div class="card bg-white dark:bg-gray-800 w-full rounded-xl p-5 border dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-300">
          <div class="flex items-center">
            <div class="p-2 max-w-sm">
              <div class="bg-gradient-to-r from-purple-200 to-pink-200 rounded-xl w-14 h-14 text-lg p-3 text-purple-600 dark:text-purple-500 mx-auto flex items-center justify-center">
                <Icon icon="mdi:account-group" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-semibold text-gray-900 dark:text-gray-200 text-2xl">
                {{ formatNumber(estadisticas.clientesActivos, 0) }}
              </p>
              <h2 class="font-normal text-gray-400 text-md mt-1">Clientes Activos</h2>
              <div class="flex items-center mt-2 text-sm">
                <Icon icon="mdi:trending-up" class="text-green-500 mr-1" v-if="estadisticas.variacionClientes > 0" />
                <Icon icon="mdi:trending-down" class="text-red-500 mr-1" v-else-if="estadisticas.variacionClientes < 0" />
                <Icon icon="mdi:minus" class="text-gray-500 mr-1" v-else />
                <span :class="[
                  estadisticas.variacionClientes > 0 ? 'text-green-600 dark:text-green-400' : 
                  estadisticas.variacionClientes < 0 ? 'text-red-600 dark:text-red-400' : 
                  'text-gray-600 dark:text-gray-400'
                ]">
                  {{ estadisticas.variacionClientes !== null ? Math.abs(estadisticas.variacionClientes) + '% vs mes anterior' : 'Sin datos previos' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección Técnica (NUEVA) -->
      <div class="grid lg:grid-cols-4 grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <!-- Caja de Hoy (NUEVA) -->
        <div class="card bg-gradient-to-br from-emerald-600 to-teal-700 text-white w-full rounded-xl p-5 shadow-lg hover:shadow-emerald-500/30 transition-all duration-300 transform hover:-translate-y-1">
          <div class="flex items-center">
            <div class="p-2">
              <div class="bg-white/20 rounded-xl w-14 h-14 flex items-center justify-center">
                <Icon icon="mdi:cash-register" class="text-3xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-bold text-3xl">{{ formatCurrencyUSD(estadisticas.ingresosHoy) }}</p>
              <h2 class="font-medium text-emerald-100 text-sm mt-1 uppercase tracking-wider">Caja de Hoy</h2>
              <p class="text-[10px] text-white/60 mt-1">Total recaudado (Ventas + Servicios)</p>
            </div>
          </div>
        </div>

        <!-- Equipos en Taller -->
        <div class="card bg-indigo-600 text-white w-full rounded-xl p-5 shadow-lg hover:shadow-indigo-500/30 transition-all duration-300 transform hover:-translate-y-1">
          <div class="flex items-center">
            <div class="p-2">
              <div class="bg-white/20 rounded-xl w-14 h-14 flex items-center justify-center">
                <Icon icon="mdi:tools" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-bold text-3xl">{{ estadisticas.reparacionesEnCurso }}</p>
              <h2 class="font-medium text-indigo-100 text-sm mt-1 uppercase tracking-wider">En Taller</h2>
              <p class="text-[10px] text-white/60 mt-1">Equipos en proceso técnico</p>
            </div>
          </div>
        </div>

        <!-- Listos para Entregar -->
        <div class="card bg-emerald-600 text-white w-full rounded-xl p-5 shadow-lg hover:shadow-emerald-500/30 transition-all duration-300 transform hover:-translate-y-1">
          <div class="flex items-center">
            <div class="p-2">
              <div class="bg-white/20 rounded-xl w-14 h-14 flex items-center justify-center">
                <Icon icon="mdi:package-variant-closed-check" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-bold text-3xl">{{ estadisticas.reparacionesListas }}</p>
              <h2 class="font-medium text-emerald-100 text-sm mt-1 uppercase tracking-wider">Por Entregar</h2>
              <p class="text-[10px] text-white/60 mt-1">Reparaciones completadas</p>
            </div>
          </div>
        </div>

        <!-- Total Reparaciones Mes -->
        <div class="card bg-white dark:bg-gray-800 w-full rounded-xl p-5 border dark:border-gray-700 shadow-sm">
          <div class="flex items-center">
            <div class="p-2">
              <div class="bg-blue-100 dark:bg-blue-900/30 rounded-xl w-14 h-14 flex items-center justify-center text-blue-600 dark:text-blue-400">
                <Icon icon="mdi:cellphone-cog" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-semibold text-gray-900 dark:text-gray-200 text-2xl">{{ estadisticas.totalReparacionesMes }}</p>
              <h2 class="font-normal text-gray-400 text-md mt-1">Órdenes este Mes</h2>
            </div>
          </div>
        </div>

        <!-- Ingresos por Servicio -->
        <div class="card bg-white dark:bg-gray-800 w-full rounded-xl p-5 border dark:border-gray-700 shadow-sm">
          <div class="flex items-center">
            <div class="p-2">
              <div class="bg-violet-100 dark:bg-violet-900/30 rounded-xl w-14 h-14 flex items-center justify-center text-violet-600 dark:text-violet-400">
                <Icon icon="mdi:cash-multiple" class="text-2xl" />
              </div>
            </div>
            <div class="block p-2 w-full">
              <p class="font-semibold text-gray-900 dark:text-gray-200 text-2xl">{{ formatCurrencyUSD(estadisticas.ingresosServicioHoy) }}</p>
              <h2 class="font-normal text-gray-400 text-md mt-1">Recaudado (Hoy)</h2>
            </div>
          </div>
        </div>
      </div>

      <!-- Gráficas principales -->
      <div class="mt-6 lg:flex block lg:gap-4 relative">
        <!-- Gráfica de Ventas Mensuales -->
        <div class="bg-white dark:bg-gray-800 p-5 lg:w-2/3 w-full rounded-xl box-border border dark:border-gray-700 shadow-sm">
          <div class="flex justify-between items-center mb-6">
            <div>
              <h2 class="font-semibold text-lg text-gray-800 dark:text-gray-200">
                Ventas Mensuales (USD)
              </h2>
              <p class="text-gray-400 text-sm">
                Evolución de los ingresos por ventas en los últimos meses
              </p>
            </div>
            <div class="flex items-center gap-4">
              <select
                v-model="periodoGrafica"
                @change="actualizarGraficaVentas"
                class="dark:bg-gray-700 dark:border-gray-600 border rounded-lg px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 font-bold outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              >
                <option value="30d">Últimos 30 días</option>
                <option value="6m">Últimos 6 meses</option>
                <option value="12m">Últimos 12 meses</option>
                <option value="ytd">Año en curso</option>
              </select>
            </div>
          </div>
          <div v-if="seriesVentas[0].data.length > 0 || seriesVentas[1].data.length > 0">
            <apexchart
              width="100%"
              height="300"
              type="area"
              :options="optionsVentas"
              :series="seriesVentas"
            ></apexchart>
          </div>
          <div v-else class="h-300 flex flex-col items-center justify-center text-gray-500 dark:text-gray-400">
            <Icon icon="mdi:chart-line" class="text-4xl mb-3" />
            <p>No hay datos de ventas para mostrar</p>
          </div>
        </div>
        
      <!-- Secciones de apoyo (Removido Métodos de Pago) -->
      </div>

      <!-- Gráficas secundarias (Removido Estado de Pagos) -->

      <!-- Top Productos y Clientes -->
      <div class="mt-6 lg:flex block lg:gap-4">
        <div class="bg-white dark:bg-gray-800 p-5 w-full rounded-xl box-border border dark:border-gray-700 shadow-sm">
          <div class="flex justify-between items-center mb-6">
            <div>
              <h2 class="font-semibold text-lg text-gray-800 dark:text-gray-200">
                Top 5 Productos
              </h2>
              <p class="text-gray-400 text-sm">Productos más vendidos del mes</p>
            </div>
            <select
              v-model="periodoTopProductos"
              @change="actualizarTopProductos"
              class="dark:bg-gray-700 dark:border-gray-600 border rounded-lg px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300"
            >
              <option value="mes">Este mes</option>
              <option value="trimestre">Este trimestre</option>
              <option value="ano">Este año</option>
            </select>
          </div>
          <div v-if="topProductos.length > 0" class="space-y-4">
            <div 
              v-for="(producto, index) in topProductos" 
              :key="producto.id"
              class="flex items-center p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <div class="w-8 h-8 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center text-white font-bold text-sm mr-4">
                {{ index + 1 }}
              </div>
              <div class="flex-1">
                <h3 class="font-medium text-gray-800 dark:text-gray-200">{{ producto.nombre }}</h3>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  {{ formatNumber(producto.cantidadVendida, 0) }} unidades vendidas
                </p>
              </div>
              <div class="text-right">
                <p class="font-semibold text-green-600 dark:text-green-400">
                  {{ formatCurrencyUSD(producto.totalVendido) }}
                </p>
                <div class="w-32 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mt-1">
                  <div 
                    class="h-full rounded-full bg-gradient-to-r from-green-500 to-emerald-500 transition-all duration-300"
                    :style="{ width: producto.porcentaje + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
            <Icon icon="mdi:package-variant-closed" class="text-4xl mx-auto mb-3" />
            <p>No hay productos vendidos</p>
          </div>
        </div>
        
        <div class="bg-white dark:bg-gray-800 p-5 lg:mt-0 mt-4 w-full rounded-xl box-border border dark:border-gray-700 shadow-sm">
          <div class="flex justify-between items-center mb-6">
            <div>
              <h2 class="font-semibold text-lg text-gray-800 dark:text-gray-200">
                Top 5 Clientes
              </h2>
              <p class="text-gray-400 text-sm">Clientes que más compran</p>
            </div>
            <select
              v-model="periodoTopClientes"
              @change="actualizarTopClientes"
              class="dark:bg-gray-700 dark:border-gray-600 border rounded-lg px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300"
            >
              <option value="mes">Este mes</option>
              <option value="trimestre">Este trimestre</option>
              <option value="ano">Este año</option>
            </select>
          </div>
          <div v-if="topClientes.length > 0" class="space-y-4">
            <div 
              v-for="(cliente, index) in topClientes" 
              :key="cliente.id"
              class="flex items-center p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <div class="w-10 h-10 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center text-white text-sm font-bold mr-4">
                {{ cliente.iniciales }}
              </div>
              <div class="flex-1">
                <h3 class="font-medium text-gray-800 dark:text-gray-200">{{ cliente.nombre }}</h3>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  {{ formatNumber(cliente.compras, 0) }} compras
                </p>
              </div>
              <div class="text-right">
                <p class="font-semibold text-blue-600 dark:text-blue-400">
                  {{ formatCurrencyUSD(cliente.totalComprado) }}
                </p>
                <div class="w-32 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mt-1">
                  <div 
                    class="h-full rounded-full bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-300"
                    :style="{ width: cliente.porcentaje + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
            <Icon icon="mdi:account-group" class="text-4xl mx-auto mb-3" />
            <p>No hay clientes con compras</p>
          </div>
        </div>
      </div>

      <!-- Últimas Ventas -->
      <div class="mt-6 bg-white dark:bg-gray-800 p-5 w-full rounded-xl box-border border dark:border-gray-700 shadow-sm">
        <div class="flex justify-between items-center mb-6">
          <div>
            <h2 class="font-semibold text-lg text-gray-800 dark:text-gray-200">
              Últimas Ventas
            </h2>
            <p class="text-gray-400 text-sm">
              {{ ultimasVentas.length }} ventas recientes
            </p>
          </div>
          <button
            @click="irAVentas"
            class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm font-medium flex items-center gap-1"
          >
            Ver todas
            <Icon icon="mdi:chevron-right" />
          </button>
        </div>
        <div v-if="ultimasVentas.length > 0" class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">Factura</th>
                <th scope="col" class="px-6 py-3">Cliente</th>
                <th scope="col" class="px-6 py-3">Monto (USD)</th>
                <th scope="col" class="px-6 py-3">Estado Pago</th>
                <th scope="col" class="px-6 py-3">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="venta in ultimasVentas" 
                :key="venta.idVenta"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                <td class="px-6 py-4">
                  <div class="font-medium text-gray-900 dark:text-white">{{ venta.numeroFactura || venta.numero_factura }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">ID: {{ venta.idVenta }}</div>
                </td>
                <td class="px-6 py-4">
                  <div class="flex items-center">
                    <div class="w-8 h-8 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center text-white text-xs font-bold mr-3">
                      {{ venta.inicialesCliente }}
                    </div>
                    <div>
                      <div class="font-medium text-gray-900 dark:text-white">{{ venta.clienteNombreFinal }}</div>
                      <div class="text-xs text-gray-500 dark:text-gray-400">ID: {{ venta.numeroFactura || venta.idVenta }}</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4">
                  <div class="font-bold text-gray-900 dark:text-white">{{ formatCurrencyUSD(venta.totalVentaFinal) }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">
                    Pagado: {{ formatCurrencyUSD(venta.totalPagado || 0) }}
                  </div>
                </td>
                <td class="px-6 py-4">
                  <span :class="getEstadoPagoColor(venta.estadoPago)">
                    {{ getEstadoPagoText(venta.estadoPago) }}
                  </span>
                </td>
                <td class="px-6 py-4">
                  <div class="text-gray-900 dark:text-white">{{ formatDate(venta.fechaVenta || venta.fecha_venta) }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">{{ formatTime(venta.fechaVenta || venta.fecha_venta) }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-center py-12 text-gray-500 dark:text-gray-400">
          <Icon icon="mdi:cash-register-off" class="text-4xl mx-auto mb-3" />
          <p>No hay ventas registradas</p>
        </div>
      </div>

      <!-- Últimas Reparaciones (NUEVA) -->
      <div class="mt-6 bg-white dark:bg-gray-800 p-5 w-full rounded-xl box-border border dark:border-gray-700 shadow-sm mb-10">
        <div class="flex justify-between items-center mb-6">
          <div>
            <h2 class="font-semibold text-lg text-gray-800 dark:text-gray-200">
              Trabajos Técnicos Recientes
            </h2>
            <p class="text-gray-400 text-sm">
              Estado actual de las últimas recepciones
            </p>
          </div>
          <button
            @click="$router.push('/reparaciones')"
            class="text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 text-sm font-medium flex items-center gap-1"
          >
            Ver todas
            <Icon icon="mdi:chevron-right" />
          </button>
        </div>
        <div v-if="ultimasReparaciones.length > 0" class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">Orden</th>
                <th scope="col" class="px-6 py-3">Equipo</th>
                <th scope="col" class="px-6 py-3">Cliente</th>
                <th scope="col" class="px-6 py-3">Estado</th>
                <th scope="col" class="px-6 py-3">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="rep in ultimasReparaciones" 
                :key="rep.idRecepcionEquipo"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                @click="$router.push(`/seguimiento/${rep.numeroOrden}`)"
              >
                <td class="px-6 py-4">
                  <div class="font-black text-indigo-600 dark:text-indigo-400">{{ rep.numeroOrden }}</div>
                  <div class="text-[10px] text-gray-400 uppercase font-bold">{{ formatDate(rep.fechaIngreso) }}</div>
                </td>
                <td class="px-6 py-4">
                  <div class="font-medium text-gray-900 dark:text-white truncate max-w-[150px]">{{ rep.descripcion }}</div>
                  <div class="text-[10px] text-gray-500">{{ rep.taller || 'Taller Central' }}</div>
                </td>
                <td class="px-6 py-4">
                  <div class="font-medium text-gray-900 dark:text-white">{{ rep.nombreCliente }}</div>
                </td>
                <td class="px-6 py-4">
                  <span :class="getEstadoStyle(rep.nombreEstado)" class="px-2 py-1 rounded text-[10px] font-bold uppercase">
                    {{ rep.nombreEstado }}
                  </span>
                </td>
                <td class="px-6 py-4">
                  <div class="font-bold text-gray-900 dark:text-white">${{ (rep.precioTotalUsd || 0).toFixed(2) }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-center py-12 text-gray-500 dark:text-gray-400">
          <Icon icon="mdi:tools" class="text-4xl mx-auto mb-3" />
          <p>No hay recepciones registradas</p>
        </div>
      </div>
    </div>
    
    <!-- Alerta de Cashea (NUEVA) -->
    <div v-if="estadisticas.cuotasCasheaSemanales > 0 || estadisticas.cuotasCasheaVencidas > 0" class="mt-6 animate-fadeIn">
      <div 
        class="bg-white dark:bg-gray-800 border-2 border-teal-500 rounded-3xl p-5 flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl shadow-teal-500/10 relative overflow-hidden"
      >
        <div class="absolute top-0 left-0 w-2 h-full bg-teal-500"></div>
        
        <div class="flex items-center gap-5">
          <div class="w-16 h-16 bg-teal-50 dark:bg-teal-900/30 rounded-2xl flex items-center justify-center text-teal-600 shadow-inner">
            <Icon icon="mdi:calendar-clock" class="text-4xl" />
          </div>
          <div>
            <div class="flex items-center gap-2 mb-1">
              <span v-if="estadisticas.cuotasCasheaVencidas > 0" class="px-2 py-0.5 bg-rose-500 text-white text-[9px] font-black rounded-md uppercase tracking-widest animate-pulse">Vencido</span>
              <span v-else class="px-2 py-0.5 bg-teal-500 text-white text-[9px] font-black rounded-md uppercase tracking-widest">Semanal</span>
              <h4 class="text-gray-400 font-black uppercase tracking-widest text-[10px]">Gestión Cashea</h4>
            </div>
            <p class="text-gray-900 dark:text-white font-black text-xl leading-none">
              {{ formatCurrencyUSD(estadisticas.montoCasheaSemanal) }} 
              <span class="text-sm font-bold text-gray-400 block mt-1 uppercase tracking-tight">
                {{ estadisticas.cuotasCasheaSemanales }} cuotas por cobrar esta semana
              </span>
            </p>
          </div>
        </div>
        
        <div class="flex items-center gap-3 w-full md:w-auto">
          <button 
            @click="$router.push({ path: '/gestion-creditos', query: { tab: 'cashea', filter: 'semanal' }})"
            class="flex-1 md:flex-none px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white rounded-2xl font-black text-xs uppercase tracking-widest transition-all shadow-lg shadow-teal-500/30 flex items-center justify-center gap-3"
          >
            <Icon icon="mdi:cash-fast" class="text-xl" />
            Cobrar Semanales
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { obtenerVentas } from '@/api/ventas.js';
import { obtenerPagosVenta } from '@/api/pagoVenta.js';
import { obtenerPagosSalidaEquipo } from '@/api/pagoSalidaEquipo.js';
import { obtenerTasaVentaActual } from '@/api/tasaVenta.js';
import { obtenerProductos } from '@/api/productos.js';
import { obtenerClientes } from '@/api/clientes.js';
import { formatearNumero, formatearPrecio } from '@/api/pagos.js';
import recepcionApi from '@/api/recepcionEquipo.js';
import { apiFetch } from '@/api/index.js';
import { useToast } from "vue-toastification";
import { obtenerResumenCreditos } from '@/api/creditoEmpresa.js';
import { agregarNotificacion } from '@/utils/notificaciones.js';

export default {
  name: "DashboardVentas",
  data() {
    return {
      loading: false,
      hayDatos: false,
      ventas: [],
      clientes: [],
      productos: [],
      pagos: [],
      estadisticas: {
        totalIngresosUSD: 0,
        totalVentas: 0,
        pendienteCobrar: 0,
        clientesActivos: 0,
        variacionIngresos: null,
        variacionVentas: null,
        variacionClientes: null,
        ventasPagadas: 0,
        ventasParciales: 0,
        ventasPendientes: 0,
        // Técnicas
        reparacionesEnCurso: 0,
        reparacionesListas: 0,
        totalReparacionesMes: 0,
        ingresosServicioMes: 0,
        ingresosHoy: 0,
        ingresosServicioHoy: 0,
        cuotasCasheaPendientes: 0,
        montoCasheaPendiente: 0,
        cuotasCasheaSemanales: 0,
        montoCasheaSemanal: 0,
        cuotasCasheaVencidas: 0
      },
      recepciones: [],
      ultimasReparaciones: [],
      periodoGrafica: '6m',
      periodoTopProductos: 'mes',
      periodoTopClientes: 'mes',
      
      optionsVentas: {
        chart: { 
          type: 'area', 
          height: 300, 
          toolbar: { show: false },
          zoom: { enabled: false },
          fontFamily: 'Inter, sans-serif'
        },
        colors: ['#3B82F6', '#8B5CF6', '#CBD5E1'], // Azul (Ventas), Violeta (Servicios), Gris (Anterior)
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 3 },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100]
          }
        },
        xaxis: {
          categories: [],
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { style: { colors: '#9CA3AF', fontSize: '11px' } }
        },
        yaxis: {
          labels: { 
            style: { colors: '#9CA3AF', fontSize: '11px' },
            formatter: (value) => '$' + this.formatNumber(value, 0)
          }
        },
        tooltip: { y: { formatter: (value) => '$' + this.formatNumber(value, 2) } },
        grid: { borderColor: '#F3F4F6', strokeDashArray: 4 },
        legend: { 
          show: true,
          position: 'top', 
          horizontalAlign: 'right', 
          fontSize: '12px', 
          fontFamily: 'Inter, sans-serif', 
          fontWeight: 600,
          labels: { colors: '#6B7280' },
          markers: { radius: 12, size: 6 }
        }
      },
      seriesVentas: [
        { name: 'Ventas (Este año)', data: [] }, 
        { name: 'Servicios (Este año)', data: [] },
        { name: 'Ventas (Año anterior)', data: [] }
      ],
      
      optionsMetodosPago: {
        chart: { type: 'donut', height: 250 },
        colors: ['#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6'],
        labels: [],
        dataLabels: { enabled: false },
        legend: { position: 'bottom', horizontalAlign: 'center', fontSize: '12px', fontFamily: 'Inter, sans-serif', labels: { colors: '#6B7280' } },
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                total: { show: true, label: 'Total', color: '#6B7280', formatter: (w) => {
                  const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  return '$' + this.formatNumber(total, 0);
                }},
                value: { show: true, color: '#111827', fontSize: '20px', fontFamily: 'Inter, sans-serif', fontWeight: 600, formatter: (value) => '$' + this.formatNumber(value, 0) }
              }
            }
          }
        }
      },
      seriesMetodosPago: [],
      metodosPagoDetalle: [],
      coloresMetodosPago: ['#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6'],
      
      optionsEstadoPagos: {
        chart: { type: 'pie', height: 200 },
        colors: ['#10B981', '#3B82F6', '#F59E0B'],
        labels: ['Pagadas', 'Parciales', 'Pendientes'],
        dataLabels: { enabled: false },
        legend: { show: false }
      },
      seriesEstadoPagos: [],
      estadosPagoDetalle: [],
      
      topProductos: [],
      topClientes: [],
      ultimasVentas: []
    };
  },
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  async mounted() {
    await this.cargarDashboard();
  },
  methods: {
    async cargarDashboard() {
      this.loading = true;
      try {
        await Promise.all([
          this.cargarVentas(),
          this.cargarRecepciones(),
          this.cargarPagos(),
          this.cargarClientes(),
          this.cargarProductos(),
          this.chequearAlertasCashea()
        ]);
        
        if (this.ventas.length > 0 || this.recepciones.length > 0) {
          this.hayDatos = true;
          this.calcularEstadisticas();
          this.actualizarGraficaVentas();
          this.actualizarEstadoPagos();
          this.actualizarMetodosPago();
          this.actualizarTopClientes();
          this.actualizarTopProductos();
          this.actualizarUltimasVentas();
        }
      } catch (error) {
        console.error('❌ Error cargando dashboard:', error);
        this.showErrorAlert('Error al cargar el dashboard: ' + error.message);
      } finally {
        this.loading = false;
      }
    },
    
    async cargarRecepciones() {
      try {
        const response = await recepcionApi.obtenerRecepciones();
        if (response?.success) {
          this.recepciones = response.data;
        }
      } catch (error) {
        console.error('❌ Error cargando recepciones:', error);
      }
    },
    
    async cargarVentas() {
      try {
        const response = await obtenerVentas();
        if (response?.success && response.data?.length > 0) {
          this.ventas = response.data;
        } else {
          this.ventas = [];
        }
      } catch (error) {
        console.error('❌ Error cargando ventas:', error);
        this.ventas = [];
      }
    },
    
    async cargarClientes() {
      try {
        const response = await obtenerClientes();
        if (response?.success && response.data?.length > 0) {
          this.clientes = response.data;
        } else {
          this.clientes = [];
        }
      } catch (error) {
        console.error('❌ Error cargando clientes:', error);
        this.clientes = [];
      }
    },
    
    async cargarProductos() {
      try {
        const response = await obtenerProductos();
        if (response?.success && response.data?.length > 0) {
          this.productos = response.data;
        } else {
          this.productos = [];
        }
      } catch (error) {
        console.error('❌ Error cargando productos:', error);
        this.productos = [];
      }
    },
    
    async cargarPagos() {
      try {
        const [respVenta, respServicio] = await Promise.all([
          obtenerPagosVenta(),
          obtenerPagosSalidaEquipo()
        ]);
        
        let pagosVenta = respVenta?.success ? respVenta.data : [];
        let pagosServicio = respServicio?.success ? respServicio.data : [];
        
        // Normalizar pagos de servicio
        const pagosServicioNormalizados = pagosServicio.map(p => ({
          ...p,
          idVenta: null,
          idRecepcionEquipo: p.idRecepcionEquipo || p.idRecepcion,
          monto: p.montoUsd || p.monto || 0,
          montoUsd: p.montoUsd || p.monto || 0,
          montoBs: p.montoBs || 0,
          fechaPago: p.fechaPago,
          estado: 'completado'
        }));

        // Normalizar pagos de venta
        const pagosVentaNormalizados = pagosVenta.map(p => ({
          ...p,
          monto: p.montoUsd || p.monto || 0,
          estado: 'completado'
        }));
        
        this.pagos = [...pagosVentaNormalizados, ...pagosServicioNormalizados];
      } catch (error) {
        console.error('❌ Error cargando pagos:', error);
        this.pagos = [];
      }
    },
    
    async chequearAlertasCashea() {
      try {
        const res = await obtenerResumenCreditos();
        if (res.success) {
          const all = [...res.data.ventas, ...res.data.reparaciones];
          const ahora = new Date();
          
          // Filtrar casheas con deuda
          const casheas = all.filter(i => i.subTipo?.toLowerCase().includes('cashea') && i.saldo > 0);
          
          this.estadisticas.cuotasCasheaPendientes = casheas.length;
          this.estadisticas.montoCasheaPendiente = casheas.reduce((acc, i) => acc + i.saldo, 0);

          // Lógica Semanal (7 días o más desde la fecha de registro/pago)
          const casheasSemanales = casheas.filter(i => {
            const fecha = new Date(i.fecha);
            const diffDias = Math.floor((ahora - fecha) / (1000 * 60 * 60 * 24));
            return diffDias >= 7;
          });

          // Lógica Vencida (10 días o más)
          const casheasVencidas = casheas.filter(i => {
            const fecha = new Date(i.fecha);
            const diffDias = Math.floor((ahora - fecha) / (1000 * 60 * 60 * 24));
            return diffDias >= 10;
          });

          this.estadisticas.cuotasCasheaSemanales = casheasSemanales.length;
          this.estadisticas.montoCasheaSemanal = casheasSemanales.reduce((acc, i) => acc + i.saldo, 0);
          this.estadisticas.cuotasCasheaVencidas = casheasVencidas.length;

          if (casheasSemanales.length > 0) {
            const ultimaNotif = localStorage.getItem('last_cashea_alert');
            const hoy = new Date().toDateString();
            
            if (ultimaNotif !== hoy) {
              // Notificación General
              agregarNotificacion({
                modulo: 'credito',
                accion: 'Pendiente',
                titulo: 'Revisión Semanal Cashea',
                detalle: `Hay ${casheasSemanales.length} cuotas de Cashea que ya cumplieron una semana. Favor procesar el cobro.`
              });

              // Notificación Crítica para SuperAdmin si hay vencidas (>10 días)
              if (casheasVencidas.length > 0) {
                agregarNotificacion({
                  modulo: 'credito',
                  accion: 'Crítico',
                  titulo: '¡ALERTA SUPER ADMIN!',
                  detalle: `Existen ${casheasVencidas.length} cuotas de Cashea con más de 10 días de atraso. Requiere facturación inmediata.`
                });
              }
              
              localStorage.setItem('last_cashea_alert', hoy);
            }
          }
        }
      } catch (e) {
        console.error('Error chequeando alertas Cashea:', e);
      }
    },
    
    calcularEstadisticas() {
      const ahora = new Date();
      const mesActual = ahora.getMonth();
      const añoActual = ahora.getFullYear();
      
      const ventasMesActual = this.ventas.filter(v => {
        const fechaVenta = new Date(v.fechaVenta || v.fecha_venta);
        return fechaVenta.getMonth() === mesActual && fechaVenta.getFullYear() === añoActual;
      });
      
      let mesAnterior = mesActual - 1;
      let añoAnterior = añoActual;
      if (mesAnterior < 0) {
        mesAnterior = 11;
        añoAnterior = añoActual - 1;
      }
      
      const ventasMesAnterior = this.ventas.filter(v => {
        const fechaVenta = new Date(v.fechaVenta || v.fecha_venta);
        return fechaVenta.getMonth() === mesAnterior && fechaVenta.getFullYear() === añoAnterior;
      });
      
      let ingresosVentasTotales = 0;
      let ingresosMesActual = 0;
      let ingresosMesAnterior = 0;
      let ingresosHoy = 0;
      let ingresosServiciosTotales = 0;
      let ingresosServicioMesActual = 0;
      let ingresosServicioHoy = 0;

      // Calcular ingresos basados en PAGOS (Dinero Real en Caja)
      this.pagos.forEach(p => {
        const monto = parseFloat(p.montoUsd || p.monto || 0);
        const fechaPago = new Date(p.fechaPago);
        
        // Clasificación por fecha
        const esHoy = fechaPago.toDateString() === ahora.toDateString();
        const esMesActual = fechaPago.getMonth() === mesActual && fechaPago.getFullYear() === añoActual;
        const esMesAnterior = fechaPago.getMonth() === mesAnterior && fechaPago.getFullYear() === añoAnterior;

        if (esHoy) {
          ingresosHoy += monto;
        }

        if (esMesActual) {
          ingresosMesActual += monto;
          // Clasificación por tipo para la tarjeta de servicios
          if (!p.idVenta) {
            ingresosServicioMesActual += monto;
            if (esHoy) {
              ingresosServicioHoy += monto;
            }
          }
        }

        if (esMesAnterior) {
          ingresosMesAnterior += monto;
        }

        // Totales históricos (percibidos)
        if (p.idVenta) {
          ingresosVentasTotales += monto;
        } else {
          ingresosServiciosTotales += monto;
        }
      });

      // Fallback para ventas antiguas que no tengan registros de pago explícitos (si aplica)
      // Pero priorizamos los pagos registrados.
      
      const totalIngresosGral = ingresosVentasTotales + ingresosServiciosTotales;
      const variacionIngresos = ingresosMesAnterior > 0 ? ((ingresosMesActual - ingresosMesAnterior) / ingresosMesAnterior) * 100 : null;
      const variacionVentas = ventasMesAnterior.length > 0 ? ((ventasMesActual.length - ventasMesAnterior.length) / ventasMesAnterior.length) * 100 : null;
      
      const treintaDiasAtras = new Date();
      treintaDiasAtras.setDate(treintaDiasAtras.getDate() - 30);
      
      const clientesActivosSet = new Set();
      this.ventas.forEach(v => {
        const fechaVenta = new Date(v.fechaVenta || v.fecha_venta);
        if (fechaVenta >= treintaDiasAtras && v.idCliente) {
          clientesActivosSet.add(v.idCliente);
        }
      });
      
      const clientesMesActualCount = [...new Set(ventasMesActual.map(v => v.idCliente).filter(Boolean))].length;
      const clientesMesAnteriorCount = [...new Set(ventasMesAnterior.map(v => v.idCliente).filter(Boolean))].length;
      const variacionClientes = clientesMesAnteriorCount > 0 ? ((clientesMesActualCount - clientesMesAnteriorCount) / clientesMesAnteriorCount) * 100 : null;
      
      let pendienteCobrar = 0;
      let ventasPendientesCount = 0;
      let ventasPagadasCount = 0;
      let ventasParcialesCount = 0;
      
      this.ventas.forEach(venta => {
        const pagosVenta = this.pagos.filter(pago => pago.idVenta === venta.idVenta);
        const totalPagado = pagosVenta.filter(p => p.estado?.toLowerCase() === 'completado').reduce((sum, p) => sum + (p.monto || 0), 0);
        const totalVenta = venta.total || venta.total_usd || 0;
        const saldo = totalVenta - totalPagado;
        
        if (saldo > 0) {
          pendienteCobrar += saldo;
          ventasPendientesCount++;
        }
        
        if (totalPagado >= totalVenta) {
          ventasPagadasCount++;
        } else if (totalPagado > 0 && totalPagado < totalVenta) {
          ventasParcialesCount++;
        }
      });
      
      this.estadisticas = {
        totalIngresosUSD: totalIngresosGral,
        totalVentas: this.ventas.length + this.recepciones.length,
        pendienteCobrar: pendienteCobrar,
        clientesActivos: clientesActivosSet.size,
        variacionIngresos: variacionIngresos !== null ? Math.round(variacionIngresos) : null,
        variacionVentas: variacionVentas !== null ? Math.round(variacionVentas) : null,
        variacionClientes: variacionClientes !== null ? Math.round(variacionClientes) : null,
        ventasPagadas: ventasPagadasCount,
        ventasParciales: ventasParcialesCount,
        ventasPendientes: ventasPendientesCount,
        // Estadísticas de Servicio Técnico
        reparacionesEnCurso: this.recepciones.filter(r => ['en taller', 'en revisión', 'esperando repuesto'].includes(r.nombreEstado?.toLowerCase())).length,
        reparacionesListas: this.recepciones.filter(r => r.nombreEstado?.toLowerCase() === 'reparado').length,
        totalReparacionesMes: this.recepciones.filter(r => {
          const fecha = new Date(r.fechaIngreso);
          return fecha.getMonth() === mesActual && fecha.getFullYear() === añoActual;
        }).length,
        ingresosServicioMes: ingresosServicioMesActual,
        ingresosHoy: ingresosHoy,
        ingresosServicioHoy: ingresosServicioHoy
      };

      this.actualizarUltimasReparaciones();
    },

    actualizarUltimasReparaciones() {
      this.ultimasReparaciones = [...this.recepciones]
        .sort((a, b) => new Date(b.fechaIngreso) - new Date(a.fechaIngreso))
        .slice(0, 5);
    },

    getEstadoStyle(estado) {
      const e = estado?.toLowerCase();
      if (e?.includes('entregado')) return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400';
      if (e?.includes('reparado')) return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
      if (e?.includes('taller') || e?.includes('revisión')) return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400';
      if (e?.includes('presupuesto')) return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400';
      return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
    },
    
    actualizarGraficaVentas() {
      const ahora = new Date();
      const categorias = [];
      const datosVentasEsteAño = [];
      const datosServiciosEsteAño = [];
      const datosVentasAñoAnterior = [];
      
      const añoActual = ahora.getFullYear();
      const añoAnteriorVal = añoActual - 1;

      if (this.periodoGrafica === '30d') {
        // Vista Diaria (Últimos 30 días)
        for (let i = 29; i >= 0; i--) {
          const fecha = new Date();
          fecha.setDate(ahora.getDate() - i);
          const diaStr = fecha.getDate() + ' ' + fecha.toLocaleString('es-ES', { month: 'short' });
          categorias.push(diaStr);

          // Ventas del día
          const vDia = this.ventas.filter(v => {
            const fv = new Date(v.fechaVenta || v.fecha_venta);
            return fv.getDate() === fecha.getDate() && fv.getMonth() === fecha.getMonth() && fv.getFullYear() === fecha.getFullYear();
          });
          datosVentasEsteAño.push(vDia.reduce((sum, v) => sum + (v.total || v.total_usd || 0), 0));

          // Servicios del día
          const sDia = this.recepciones.filter(r => {
            const fr = new Date(r.fechaIngreso);
            return fr.getDate() === fecha.getDate() && fr.getMonth() === fecha.getMonth() && fr.getFullYear() === fecha.getFullYear();
          });
          datosServiciosEsteAño.push(sDia.reduce((sum, r) => sum + (r.precioTotalUsd || 0), 0));
          
          // El año anterior no se suele mostrar día a día en comparación directa de 30 días por simplicidad, o se deja en 0
          datosVentasAñoAnterior.push(0);
        }
      } else {
        // Vista Mensual
        let numMeses = this.periodoGrafica === '6m' ? 6 : (this.periodoGrafica === '12m' ? 12 : ahora.getMonth() + 1);
        
        for (let i = numMeses - 1; i >= 0; i--) {
          const fecha = new Date();
          fecha.setMonth(ahora.getMonth() - i);
          const mes = fecha.toLocaleString('es-ES', { month: 'short' });
          categorias.push(mes.charAt(0).toUpperCase() + mes.slice(1));
          
          // Ventas este año
          const vMes = this.ventas.filter(v => {
            const fv = new Date(v.fechaVenta || v.fecha_venta);
            return fv.getMonth() === fecha.getMonth() && fv.getFullYear() === añoActual;
          });
          datosVentasEsteAño.push(vMes.reduce((sum, v) => sum + (v.total || v.total_usd || 0), 0));

          // Servicios este año
          const sMes = this.recepciones.filter(r => {
            const fr = new Date(r.fechaIngreso);
            return fr.getMonth() === fecha.getMonth() && fr.getFullYear() === añoActual;
          });
          datosServiciosEsteAño.push(sMes.reduce((sum, r) => sum + (r.precioTotalUsd || 0), 0));
          
          // Ventas año anterior
          const vMesAnt = this.ventas.filter(v => {
            const fv = new Date(v.fechaVenta || v.fecha_venta);
            return fv.getMonth() === fecha.getMonth() && fv.getFullYear() === añoAnteriorVal;
          });
          datosVentasAñoAnterior.push(vMesAnt.reduce((sum, v) => sum + (v.total || v.total_usd || 0), 0));
        }
      }
      
      this.optionsVentas = { ...this.optionsVentas, xaxis: { ...this.optionsVentas.xaxis, categories: categorias } };
      this.seriesVentas = [
        { name: 'Ventas (Este año)', data: datosVentasEsteAño }, 
        { name: 'Servicios (Este año)', data: datosServiciosEsteAño },
        { name: 'Ventas (Año anterior)', data: datosVentasAñoAnterior }
      ];
    },
    
    actualizarMetodosPago() {
      const pagosCompletados = this.pagos.filter(p => p.estado?.toLowerCase() === 'completado');
      const metodosMap = {};
      
      pagosCompletados.forEach(pago => {
        let metodo = pago.metodoPago || pago.nombreMetodoPago || 'S/M';
        if (metodo === 'Desconocido' || metodo === 'OTROS MÉTODOS') metodo = 'S/M';
        const monto = pago.monto || 0;
        
        if (!metodosMap[metodo]) {
          metodosMap[metodo] = { nombre: metodo, monto: 0, cantidad: 0 };
        }
        metodosMap[metodo].monto += monto;
        metodosMap[metodo].cantidad++;
      });
      
      let metodosArray = Object.values(metodosMap);
      
      if (metodosArray.length === 0 && this.ventas.length > 0) {
        metodosArray = [{ nombre: 'Sin pagos registrados', monto: 0, cantidad: 0 }];
      }
      
      const total = metodosArray.reduce((sum, metodo) => sum + metodo.monto, 0);
      
      this.metodosPagoDetalle = metodosArray.map(metodo => ({
        ...metodo,
        porcentaje: total > 0 ? Math.round((metodo.monto / total) * 100) : 0
      }));
      
      this.seriesMetodosPago = this.metodosPagoDetalle.map(m => m.monto);
      this.optionsMetodosPago = { ...this.optionsMetodosPago, labels: this.metodosPagoDetalle.map(m => m.nombre) };
    },
    
    actualizarEstadoPagos() {
      let totalPagadas = 0, totalParciales = 0, totalPendientes = 0;
      let cantidadPagadas = 0, cantidadParciales = 0, cantidadPendientes = 0;
      
      this.ventas.forEach(venta => {
        const pagosVenta = this.pagos.filter(pago => pago.idVenta === venta.idVenta);
        const totalPagado = pagosVenta.filter(p => p.estado?.toLowerCase() === 'completado').reduce((sum, p) => sum + (p.monto || 0), 0);
        const totalVenta = venta.total || venta.total_usd || 0;
        
        if (totalPagado >= totalVenta) {
          totalPagadas += totalVenta;
          cantidadPagadas++;
        } else if (totalPagado > 0 && totalPagado < totalVenta) {
          totalParciales += totalVenta;
          cantidadParciales++;
        } else {
          totalPendientes += totalVenta;
          cantidadPendientes++;
        }
      });
      
      this.seriesEstadoPagos = [totalPagadas, totalParciales, totalPendientes];
      const totalGeneral = totalPagadas + totalParciales + totalPendientes;
      
      if (totalGeneral > 0) {
        this.estadosPagoDetalle = [
          { nombre: 'Pagadas', monto: totalPagadas, cantidad: cantidadPagadas, porcentaje: Math.round((totalPagadas / totalGeneral) * 100), color: 'bg-gradient-to-r from-green-500 to-emerald-500', icono: 'mdi:cash-check' },
          { nombre: 'Parciales', monto: totalParciales, cantidad: cantidadParciales, porcentaje: Math.round((totalParciales / totalGeneral) * 100), color: 'bg-gradient-to-r from-blue-500 to-cyan-500', icono: 'mdi:cash-multiple' },
          { nombre: 'Pendientes', monto: totalPendientes, cantidad: cantidadPendientes, porcentaje: Math.round((totalPendientes / totalGeneral) * 100), color: 'bg-gradient-to-r from-amber-500 to-orange-500', icono: 'mdi:cash-clock' }
        ];
      } else {
        this.estadosPagoDetalle = [];
      }
    },
    
    actualizarTopProductos() {
      const productosVendidos = {};
      
      this.ventas.forEach(venta => {
        const detalles = venta.detalles || [];
        detalles.forEach(detalle => {
          const productoId = detalle.idProducto;
          const productoNombre = detalle.productoNombre || detalle.nombreProducto || `Producto ${productoId}`;
          const cantidad = detalle.cantidad || 0;
          const subtotal = detalle.subtotal || detalle.subtotal_usd || 0;
          
          if (!productosVendidos[productoId]) {
            productosVendidos[productoId] = { id: productoId, nombre: productoNombre, cantidadVendida: 0, totalVendido: 0 };
          }
          productosVendidos[productoId].cantidadVendida += cantidad;
          productosVendidos[productoId].totalVendido += subtotal;
        });
      });
      
      let productosArray = Object.values(productosVendidos);
      productosArray.sort((a, b) => b.totalVendido - a.totalVendido);
      const top5 = productosArray.slice(0, 5);
      const maxVendido = top5.length > 0 ? Math.max(...top5.map(p => p.totalVendido)) : 0;
      
      this.topProductos = top5.map(p => ({ ...p, porcentaje: maxVendido > 0 ? Math.round((p.totalVendido / maxVendido) * 100) : 0 }));
    },
    
    actualizarTopClientes() {
      const ventasPorCliente = {};
      
      this.ventas.forEach(venta => {
        const clienteId = venta.idCliente;
        if (!clienteId) return;
        
        const clienteNombre = venta.clienteNombre || venta.nombreCliente || this.clientes.find(c => c.idCliente === clienteId)?.nombre || `Cliente ${clienteId}`;
        
        if (!ventasPorCliente[clienteId]) {
          ventasPorCliente[clienteId] = { id: clienteId, nombre: clienteNombre, compras: 0, totalComprado: 0 };
        }
        ventasPorCliente[clienteId].compras += 1;
        ventasPorCliente[clienteId].totalComprado += venta.total || venta.total_usd || 0;
      });
      
      let clientesArray = Object.values(ventasPorCliente);
      clientesArray.sort((a, b) => b.totalComprado - a.totalComprado);
      const top5 = clientesArray.slice(0, 5);
      const maxComprado = top5.length > 0 ? Math.max(...top5.map(c => c.totalComprado)) : 0;
      
      this.topClientes = top5.map(cliente => ({
        ...cliente,
        iniciales: this.getInicialesCliente(cliente.nombre),
        porcentaje: maxComprado > 0 ? Math.round((cliente.totalComprado / maxComprado) * 100) : 0
      }));
    },
    
    actualizarUltimasVentas() {
      const ultimas5Ventas = [...this.ventas].sort((a, b) => new Date(b.fechaVenta || b.fecha_venta || 0) - new Date(a.fechaVenta || a.fecha_venta || 0)).slice(0, 5);
      
      this.ultimasVentas = ultimas5Ventas.map(venta => {
        const pagosVenta = this.pagos.filter(pago => pago.idVenta === venta.idVenta);
        const totalPagado = pagosVenta.filter(p => p.estado?.toLowerCase() === 'completado').reduce((sum, p) => sum + (p.monto || 0), 0);
        const totalVenta = venta.totalUsd || venta.total || venta.total_usd || 0;
        
        // Buscar nombre de cliente si no viene en la venta
        let nombreFinal = venta.clienteNombre || venta.nombreCliente;
        if (!nombreFinal && venta.idCliente) {
          const cliente = this.clientes.find(c => (c.idCliente || c.id) === venta.idCliente);
          if (cliente) nombreFinal = cliente.nombre || cliente.clienteNombre || cliente.nombreCompleto;
        }
        
        if (!nombreFinal) nombreFinal = 'Cliente #' + (venta.idCliente || 'S/N');
        
        let estadoReal = 'Pendiente';
        if (totalPagado >= totalVenta) {
          estadoReal = 'Pagada';
        } else if (totalPagado > 0 && totalPagado < totalVenta) {
          estadoReal = 'Parcial';
        }
        
        return {
          ...venta,
          clienteNombreFinal: nombreFinal,
          estadoPago: estadoReal,
          totalVentaFinal: totalVenta,
          totalPagado: totalPagado,
          inicialesCliente: this.getInicialesCliente(nombreFinal)
        };
      });
    },
    
    async refreshDashboard() {
      await this.cargarDashboard();
      this.showSuccessAlert('Dashboard actualizado', 'Los datos se han actualizado correctamente');
    },
    
    exportReport() {
      this.showSuccessAlert('Exportando reporte', 'El reporte se está generando...');
    },
    
    irAVentas() {
      this.$router.push('/ventas');
    },
    
    formatNumber(num, decimals = 2) {
      return formatearNumero(num, decimals);
    },
    
    formatCurrencyUSD(monto) {
      return formatearPrecio(monto, 'USD');
    },
    
    formatDate(fechaISO) {
      if (!fechaISO) return 'N/A';
      try {
        const fecha = new Date(fechaISO);
        return fecha.toLocaleDateString('es-ES', { year: 'numeric', month: 'short', day: 'numeric' });
      } catch {
        return 'Fecha inválida';
      }
    },
    
    formatTime(fechaISO) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        return fecha.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      } catch {
        return '';
      }
    },
    
    getInicialesCliente(nombreCompleto) {
      if (!nombreCompleto) return '??';
      const partes = nombreCompleto.split(' ');
      if (partes.length === 1) return partes[0].charAt(0).toUpperCase();
      return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase();
    },
    
    getEstadoPagoText(estado) {
      switch (estado?.toLowerCase()) {
        case 'pagada': return 'Pagado';
        case 'parcial': return 'Parcial';
        case 'pendiente': return 'Pendiente';
        default: return estado || 'Pendiente';
      }
    },
    
    getEstadoPagoColor(estado) {
      switch (estado?.toLowerCase()) {
        case 'pagada': return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        case 'parcial': return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
        case 'pendiente': return 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200';
        default: return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
      }
    },
    
    showSuccessAlert(title, text) {
      this.toast.success(text || title);
    },
    
    showErrorAlert(text) {
      this.toast.error(text);
    }
  }
};
</script>

<style scoped>
.dashboard { font-family: 'Inter', sans-serif; }
.wrapper-card .card { transition: all 0.3s ease; }
.wrapper-card .card:hover { transform: translateY(-2px); }
.apexcharts-tooltip { font-family: 'Inter', sans-serif !important; }
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 3px; }
::-webkit-scrollbar-thumb { background: #888; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #555; }
.dark ::-webkit-scrollbar-track { background: #374151; }
.dark ::-webkit-scrollbar-thumb { background: #6B7280; }
</style>